module.exports = __webpack_public_path__ + "web/img/chapter-err-ai.921384ac.png";